import { z } from "zod";
import { ContentItemSchema } from "../../fragments/ContentItem";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
export const ContentItemBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    content: ContentItemSchema,
});
export const ContentItemBladeTypeValues = ["assetHighlight", "articleMediaEmbed", "landingMediaEmbed"];
export const ContentItemBladeTypesSchema = z.enum(ContentItemBladeTypeValues);
export const ContentItemBladeTypes = ContentItemBladeTypesSchema.enum;
export const ContentItemBladesContractSchema = ContentItemBladeSchema.extend({
    type: ContentItemBladeTypesSchema,
});
export const AssetHighlightContractSchema = ContentItemBladeSchema.extend({
    type: z.literal(ContentItemBladeTypes.assetHighlight),
});
export const ArticleMediaEmbedContractSchema = ContentItemBladeSchema.extend({
    type: z.literal(ContentItemBladeTypes.articleMediaEmbed),
});
export const LandingMediaEmbedContractSchema = ContentItemBladeSchema.extend({
    type: z.literal(ContentItemBladeTypes.landingMediaEmbed),
});
//# sourceMappingURL=index.js.map